import { Injectable } from '@angular/core';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';
import { environmentv3 } from 'src/environments/environmentv3';
import { ConcessionarioPessoaDTO, ConcessionarioPessoaDTOList } from '../../model/dtos/mob/concessionario-pessoa.dto';
import { ApiController } from '../api-controller.interface';

@Injectable()
export class ConcessionarioPessoaController implements ApiController<ConcessionarioPessoaDTO>{

	constructor() { }

	find(filters?: IFilter): Promise<ConcessionarioPessoaDTO[]> {
		throw new Error('Method not implemented.');
	}

	ativar(entity: ConcessionarioPessoaDTO): Promise<ConcessionarioPessoaDTO> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/concessionariopessoa/:cdConcessionarioPessoa/ativar',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdConcessionarioPessoa: entity.cdConcessionarioPessoa
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse( new ConcessionarioPessoaDTO())
        );
        return request.call();  

    }

    desativar(entity: ConcessionarioPessoaDTO): Promise<ConcessionarioPessoaDTO> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/concessionariopessoa/:cdConcessionarioPessoa/inativar',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdConcessionarioPessoa: entity.cdConcessionarioPessoa
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse( new ConcessionarioPessoaDTO())
        );
        return request.call();  
    }

	findConcessionarioPessoa(filters?: IFilter): Promise<ConcessionarioPessoaDTOList> {
		let request = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/concessionariopessoa',
					environment: environmentv3,
					filter: filters,
				}),
			}),
			new HttpResponse(new ConcessionarioPessoaDTOList())
		);
		return request.call();
	}

	findHistorico(filters?: IFilter): Promise<ConcessionarioPessoaDTOList> {
        let request = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/concessionariopessoa/historico',
					environment: environmentv3,
					filter: filters,
				}),
			}),
			new HttpResponse(new ConcessionarioPessoaDTOList())
		);
		return request.call();
    }

	get(id: number): Promise<ConcessionarioPessoaDTO> {
		let request = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/concessionariopessoa/:cdConcessionarioPessoa',
					environment: environmentv3,
					pathParams: new JSONData({
						cdConcessionarioPessoa: id
					}),
				}),
			}),
			new HttpResponse(new ConcessionarioPessoaDTO())
		);
		return request.call();
	}

	create(entity: ConcessionarioPessoaDTO): Promise<ConcessionarioPessoaDTO> {
		let request = new Quark(
			new HttpPost({
				url: new Url({
					id: 'mob/concessionariopessoa',
					environment: environmentv3
				}),
				data: new JSONData(entity)
			}),
			new HttpResponse(
				new ConcessionarioPessoaDTO()
			)
		);
		return request.call();
	}

	update(entity: ConcessionarioPessoaDTO): Promise<ConcessionarioPessoaDTO> {
		let request = new Quark(
			new HttpPut({
				url: new Url({
					id: 'mob/concessionariopessoa/:cdConcessionarioPessoa',
					environment: environmentv3,
					pathParams: new JSONData({
						cdConcessionarioPessoa: entity.cdConcessionarioPessoa
					})
				}),
				data: new JSONData(entity)
			}),
			new HttpResponse(
				new ConcessionarioPessoaDTO()
			)
		);
		return request.call();
	}

	async findColetivoRural(filtros?: IFilter): Promise<Array<ConcessionarioPessoaDTO>> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/concessionariospessoas/findcoletivorural',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<ConcessionarioPessoaDTO>()
			)
		);
		return await quark.call();
	}

	async findTaxi(filtros?: IFilter): Promise<Array<ConcessionarioPessoaDTO>> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/concessionariospessoas/findtaxi',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<ConcessionarioPessoaDTO>()
			)
		);
		return await quark.call();
	}

	async findPermissionarioTaxi(filtros?: IFilter): Promise<Array<ConcessionarioPessoaDTO>> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/concessionariospessoas/findpermissionariotaxi',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<ConcessionarioPessoaDTO>()
			)
		);
		return await quark.call();
	}

	async findColetivoUrbano(filtros?: IFilter): Promise<Array<ConcessionarioPessoaDTO>> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/concessionariospessoas/findcoletivourbano',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<ConcessionarioPessoaDTO>()
			)
		);
		return await quark.call();
	}
}